import axios from "axios";
import { useEffect, useState } from "react";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import formatDate from "../../util/dateFormat";
import { useAppDispatch } from "../../redux/hooks";
import { memberActions } from "../../redux/slices/memberSlice";
import moment from "moment";
import useGetTotalRecords from "../CustomHooks/UseGetTotalRecords";
import { carParkFilter } from "../../constants/AppConstants";

interface CarparkLogs {
  campaign_name: string;
  utilized_dollars?: number;
  date: number;
  balance: number;
  iu_number: string;
  reward_name: string;
  message: string;
  email: string;
  id: string;
  vehicle_no: string;
  redeem_dollars?: number;
  transaction_date: string;
}
const useGetCarparkLogs = () => {
  const dispatch = useAppDispatch();
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const [loading, setLoading] = useState<boolean>(false);
  const [lastKey, setLastKey] = useState(null);
  const [carParkLogData, setCarParkLogData] = useState([]);

  const [transactionTypeList, setTransactionTypeList] = useState<any>([]);

  useEffect(() => {
    const carParkKeys = Object.keys(carParkFilter);
    const options = carParkKeys?.map((data: string) => {
      return  carParkFilter[data]
    });
    setTransactionTypeList(options);
  }, []);

  const fetchCarParkLogs = async (urlString?: string, mergeData?: boolean) => {
    setLoading(true);
    let currentURl = `${process.env.REACT_APP_API_URL}${APIConstants.carParkLogs}`;
    if (urlString) currentURl += `?${urlString}`;
    try {
      if (!carParkLogData.length)
        getTotalRecordsCount(APIModuleConstants.memberCarparkLogs, urlString);
      if (lastKey) {
        currentURl += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }

      const response = await axios.get(currentURl);

      if (response.status === 200) {
        const keySet = response?.data?.lastKey;
        setLastKey(keySet ? keySet : null);
        const mappedData = response.data.data.map((log: any) => {
          log.transaction_date = formatDate(log.transaction_date);
          return {
            ...log,
            redeemCarParkDollars:
              log.transaction_type === "Redeemed" ? log.amount : "0",
            utilizedCarParkDollars:
              log.transaction_type !== "Redeemed" ? log.amount : "0",

            date: formatDate(log.transaction_date),
          };
        });
        const dataSet = mergeData
          ? [...carParkLogData, ...mappedData]
          : mappedData;
        setCarParkLogData(dataSet);
        dispatch(memberActions.updateCarParkLogs({ carParkLogs: dataSet }));
      }
    } catch (error) {
      console.error(error);
      setLastKey(null);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return {
    fetchCarParkLogs,
    loading,
    lastKey,
    carParkLogData,
    transactionTypeList,
    totalCount,
    setLastKey,
    setCarParkLogData,
  };
};

export default useGetCarparkLogs;
